const SPRITE_URL = 'https://cdn.shopify.com/s/files/1/0441/5019/4336/files/lvtxiii-pattern-sprite-101.webp?v=1788259924';
const COLUMNS = 11;
const ROWS = 10;
const SOURCE_CELL = 48;
const POSITIONS = {
  BDZY:[0,0],BJYZ:[1,0],CSBZ:[2,0],CSHT:[3,0],CSSH:[4,0],CSYD:[5,0],DXYQ:[6,0],FGBH:[7,0],FGHT:[8,0],FGSY:[9,0],FLHT:[10,0],
  FYWH:[0,1],GDLW:[1,1],HBFH:[2,1],HBMS:[3,1],HBTW:[4,1],HDBH:[5,1],HDJH:[6,1],HDLH:[7,1],HDXRK:[8,1],HJYZ:[9,1],HLHT:[10,1],
  HLKT:[0,2],HLVHT:[1,2],HSJH:[2,2],HSMP:[3,2],HXT:[4,2],HYZ:[5,2],HZHT:[6,2],JBLY:[7,2],JLZL:[8,2],JRHH:[9,2],LANFD:[10,2],
  LANSY:[0,3],LBFH:[1,3],LBJY:[2,3],LCHH:[3,3],LDLH:[4,3],LDXH:[5,3],LGBY:[6,3],LHMD:[7,3],LJH:[8,3],LJLH:[9,3],LLHX:[10,3],
  LLLX:[0,4],LLXT:[1,4],LLYZ:[2,4],LSCL:[3,4],LVSY:[4,4],LVZL:[5,4],LVZYZ:[6,4],LXJY:[7,4],LYD:[8,4],LYLH:[9,4],LYMG:[10,4],
  LYWH:[0,5],LZRG:[1,5],MCYZ:[2,5],MHHT:[3,5],MXT:[4,5],MZXT:[5,5],NZFG:[6,5],NZKT:[7,5],NZXT:[8,5],OLFBE:[9,5],OLFDG:[10,5],
  OLFRE:[0,6],QHBT:[1,6],QHHT:[2,6],QHYQ:[3,6],QLHT:[4,6],QLVHT:[5,6],QLYH:[6,6],RDYH:[7,6],SMBH:[8,6],SMYZ:[9,6],SSGZ:[10,6],
  TWHL:[0,7],TWYWH:[1,7],TXHY:[2,7],WZQH:[3,7],XBDHTH:[4,7],XHFH:[5,7],XHH:[6,7],XHTH:[7,7],XLFH:[8,7],XLH:[9,7],XLT:[10,7],
  YDFG:[0,8],YGTW:[1,8],ZQBH:[2,8],ZQBT:[3,8],ZQBY:[4,8],ZQHT:[5,8],ZQJH:[6,8],ZQMP:[7,8],ZQTW:[8,8],ZQWJ:[9,8],ZQYG:[10,8],
  ZSQNH:[0,9],ZYH:[1,9]
};

function decorate(root = document) {
  for (const link of root.querySelectorAll?.('.lvtxiii-card-patterns__swatch[data-pattern-code]') ?? []) {
    if (link.dataset.patternReady === 'true') continue;
    const position = POSITIONS[link.dataset.patternCode];
    const tile = link.firstElementChild;
    if (!position || !(tile instanceof HTMLElement)) {
      link.hidden = true;
      continue;
    }
    const size = tile.clientWidth || 24;
    const scale = size / SOURCE_CELL;
    tile.style.backgroundImage = `url("${SPRITE_URL}")`;
    tile.style.backgroundSize = `${COLUMNS * SOURCE_CELL * scale}px ${ROWS * SOURCE_CELL * scale}px`;
    tile.style.backgroundPosition = `${-position[0] * SOURCE_CELL * scale}px ${-position[1] * SOURCE_CELL * scale}px`;
    link.dataset.patternReady = 'true';
  }
}

decorate();
document.addEventListener('DOMContentLoaded', () => decorate(), { once: true });
document.addEventListener('shopify:section:load', (event) => decorate(event.target));
new MutationObserver((changes) => {
  for (const change of changes) for (const node of change.addedNodes) if (node instanceof Element) decorate(node);
}).observe(document.documentElement, { childList: true, subtree: true });

